import axios from 'axios'
import emailjs from '@emailjs/browser'

export const makeUuid = () => {
  const { v4: uuidv4 } = require('uuid')
  return uuidv4()
}

/**
 * Submit proof of purchase to s3
 *
 * @param file
 * @param fieldName
 */
export const submitS3ImageUpload = async (file: File, fieldName: string, uuid: string) => {
  const formData = new FormData()
  formData.append(fieldName, file)
  formData.append(fieldName, uuid)
  await axios({
    method: 'POST',
    url: '/api/aws/s3/upload',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(res => console.log(res.data))
}

export const makeDate = (dateString: string) => {
  const dateParts = dateString.split('-')
  return new Date(
    parseInt(dateParts[0]), // year
    parseInt(dateParts[1]) > 0 // month - 1 because it's 0 index based
      ? parseInt(dateParts[1]) - 1
      : parseInt(dateParts[1]),
    parseInt(dateParts[2]) // day
  )
}

export const sendEmail = (
  serviceId: string,
  templateId: string,
  formData: string,
  userId: string
) => {
  emailjs.sendForm(serviceId, templateId, formData, userId).then(
    result => {
      console.log(result)
    },
    error => {
      console.log(error.text)
    }
  )
}
